export const PLATFORMS = {
  ios: 'iOS (iPhone/iPad)',
  android: 'Android',
  desktop: 'Desktop',
};



// WEBPACK FOOTER //
// ./src/config/platforms.js